import React from 'react';
import { ProjectModel } from '@bryntum/scheduler';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumSchedulerProjectModel extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
        this.dataStores = {
            'assignmentStore': 'assignments',
            'dependencyStore': 'dependencies',
            'eventStore': 'events',
            'resourceStore': 'resources',
            'resourceTimeRangeStore': 'resourceTimeRanges',
            'timeRangeStore': 'timeRanges'
        };
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        return null;
    }
}
BryntumSchedulerProjectModel.instanceClass = ProjectModel;
BryntumSchedulerProjectModel.instanceName = 'ProjectModel';
BryntumSchedulerProjectModel.configNames = [
    'adjustDurationToDST',
    'assignmentModelClass',
    'assignmentsData',
    'assignmentStoreClass',
    'children',
    'dependenciesData',
    'dependencyModelClass',
    'dependencyStoreClass',
    'eventModelClass',
    'eventsData',
    'eventStoreClass',
    'expanded',
    'orderedParentIndex',
    'parentId',
    'parentIndex',
    'resourceModelClass',
    'resourcesData',
    'resourceStoreClass',
    'resourceTimeRangesData',
    'resourceTimeRangeStoreClass',
    'silenceInitialCommit',
    'timeRangesData',
    'timeRangeStoreClass',
    'toJSONResultFormat'
];
BryntumSchedulerProjectModel.propertyConfigNames = [
    'assignments',
    'assignmentStore',
    'dependencies',
    'dependencyStore',
    'events',
    'eventStore',
    'id',
    'json',
    'onChange',
    'onDataReady',
    'readOnly',
    'resources',
    'resourceStore',
    'resourceTimeRanges',
    'resourceTimeRangeStore',
    'shouldSyncDataOnLoad',
    'stm',
    'timeRanges',
    'timeRangeStore',
    'timeZone'
];
BryntumSchedulerProjectModel.propertyNames = [
    'allChildren',
    'descendantCount',
    'hasGeneratedId',
    'inlineData',
    'internalId',
    'isCommitting',
    'isCreating',
    'isValid',
    'previousSiblingsTotalCount',
    'visibleDescendantCount'
];
//# sourceMappingURL=BryntumSchedulerProjectModel.js.map